import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import ResultItem from './ResultItem';
const ResultsList = ({ results, activeIndex, onSelect, }) => {
    const listRef = useRef(null);
    const itemRefs = useRef([]);
    // Scroll active item into view
    useEffect(() => {
        if (activeIndex >= 0 && activeIndex < results.length && itemRefs.current[activeIndex]) {
            itemRefs.current[activeIndex]?.scrollIntoView({
                block: 'nearest',
                behavior: 'smooth',
            });
        }
    }, [activeIndex, results.length]);
    if (results.length === 0) {
        return null;
    }
    return (_jsx("ul", { className: "eno-search-results", ref: listRef, children: results.map((result, index) => (_jsx("li", { ref: (el) => {
                itemRefs.current[index] = el;
            }, children: _jsx(ResultItem, { result: result, isActive: index === activeIndex, onClick: () => onSelect(result) }) }, `${result.product.id}-${index}`))) }));
};
export default ResultsList;
